module.exports = __webpack_public_path__ + "static/media/hover.7150f70f.svg";